import React from 'react';
import './ImageWithActions.css';
import CustomButton from '../../b2b-common/CustomButton';
import { generateClassName } from '../../b2b-common/helpers';

const ImageWithActions = ({ src, alt, imageName, onEdit, onDelete, confirmDelete = true, className }) => {
    //console.log('ImageWithActions:', src, alt, onEdit, onDelete, className);
    const handleDelete = () => {
        if (confirmDelete) {
            if (window.confirm(`Are you sure you want to delete ${imageName}?`)) {
                onDelete();
            }
        } else {
            onDelete();
        }
    }

    return (
        <div className={generateClassName(className, '-container', 'image-with-actions')}>
            <div className={generateClassName(className, '-label', 'image-with-actions')}>{alt}</div>
            <img src={src} alt={alt} />
            <div className={generateClassName(className, '-buttons', 'image-with-actions')}>
                {onEdit && <CustomButton label="Edit" variant="contained" color="primary" onClick={onEdit} />}
                {onDelete && <CustomButton label="Delete" variant="contained" color="primary" onClick={handleDelete} />}
            </div>
        </div>
    );
};

export default ImageWithActions;